module.exports = __webpack_public_path__ + "static/img/Sharn-Freier.4d87d38.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Sharn-Freier.jpg
// module id = Z88f
// module chunks = 0